// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3XASu","label":"CategoryService_label__bCSta","location":"CategoryService_location__39T6O"};